import React, { Component } from "react";
import { propertyUtil } from "views/Pma/PropertyUtil";
import White40Percent from "./valueChangedTransparentBox.png";
import { hasDisplayValue, isFieldVisible } from "./rangeDisplayUtils";

class DashboardBodyRange extends Component {
  getBathroomDecimals = (baths, halfBaths, rangeNum) => {
    if (`${baths}`.includes(".")) {
      return `${baths} bathrooms`;
    }
    if (!halfBaths || halfBaths !== "0") {
      return `${baths}+ bathrooms`;
    } else {
      return `${baths}.5 bathrooms`;
    }
  };
  getHomeOrCondo = (num) => {
    const { mlsAreaID } = this.props.currentArea;
    let homeOrCondo = "home";
    if (mlsAreaID === "SBA-20FCondo") {
      if (num === "1") {
        homeOrCondo = "condo has";
      } else {
        homeOrCondo = "condos have";
      }
    } else {
      if (num === "1") {
        homeOrCondo = "home has";
      } else {
        homeOrCondo = "homes have";
      }
    }
    return homeOrCondo;
  };
  homeOrProperties = (homesSold) => {
    const { listgenUserID } = this.props.agentData;
    const { mlsAreaID } = this.props.currentArea;

    if (mlsAreaID === "SBA-20FCondo") {
      if (homesSold === "1") {
        return "Condo";
      } else {
        return "Condos";
      }
    } else if (
      listgenUserID === "101006" ||
      listgenUserID === "100560" ||
      mlsAreaID === "SBA-20FInv"
    ) {
      if (homesSold === "1") {
        return "Property";
      } else {
        return "Properties";
      }
    } else {
      if (homesSold === "1") {
        return "Home";
      } else {
        return "Homes";
      }
    }
  };

  canShowField = (key) => {
    return isFieldVisible(this.props.fieldVisibility, key);
  };

  canRenderOverrideField = (key, value) => {
    return this.canShowField(key) && hasDisplayValue(value);
  };

  renderEditButton = () => {
    const { showEditButton, onEditClick, editDisabled, rangeNum, isEdited } =
      this.props;
    if (!showEditButton) {
      return null;
    }
    return (
      <button
        type="button"
        className={`dashboard-body-range-edit-btn${
          isEdited ? " is-edited" : ""
        }`}
        onClick={onEditClick}
        disabled={editDisabled}
        title={isEdited ? "This range has customized text" : undefined}
      >
        Edit Range #{rangeNum}
        {isEdited ? <span className="edited-badge">Edited</span> : null}
      </button>
    );
  };

  renderOverrideContent = (displayOverrides) => {
    const { rangeNum, agentData } = this.props;
    const { listgenUserID } = agentData;
    let propAttributesTitle = "Common Property Attributes";
    if (listgenUserID === "106531") {
      propAttributesTitle = "Average Home Features";
    }
    if (listgenUserID === "112334") {
      propAttributesTitle = "Average Property Amenities";
    }

    const show = this.canRenderOverrideField;

    const { useTwoSectionLayout } = this.props;

    return (
      <div
        className={`dashboard-body-range${
          useTwoSectionLayout ? " dashboard-body-range-two-sections" : ""
        }`}
      >
        <div className="price-range-col">
          <div className="price-range-inner-container">
            {show("priceRange", displayOverrides.priceRange) ? (
              <div className="price-range-text">
                {displayOverrides.priceRange}
              </div>
            ) : (
              <div className="price-range-text" aria-hidden="true" />
            )}
            {show("rangeSubtitle", displayOverrides.rangeSubtitle) ? (
              <div className="price-range-number">
                {displayOverrides.rangeSubtitle}
              </div>
            ) : (
              <div className="price-range-number" aria-hidden="true" />
            )}
          </div>
        </div>

        <div
          className={`range-details-col-with-image range-detail-${rangeNum}`}
        >
          <div className="range-details-inner-container">
            <div className="range-property-details">
              {show("homesSold", displayOverrides.homesSold) ? (
                <p>{displayOverrides.homesSold}</p>
              ) : null}
              {show("daysToSell", displayOverrides.daysToSell) ? (
                <p>{displayOverrides.daysToSell}</p>
              ) : null}
            </div>
            <div className="property-attributes">
              <p className="property-attributes-title">{propAttributesTitle}</p>
              {show("beds", displayOverrides.beds) ? (
                <p className="property-attributes-text">
                  {displayOverrides.beds}
                </p>
              ) : null}
              {show("baths", displayOverrides.baths) ? (
                <p className="property-attributes-text">
                  {displayOverrides.baths}
                </p>
              ) : null}
              {show("sqft", displayOverrides.sqft) ? (
                <p className="property-attributes-text">
                  {displayOverrides.sqft}
                </p>
              ) : null}
              {show("garage", displayOverrides.garage) ? (
                <p className="property-attributes-text">
                  {displayOverrides.garage}
                </p>
              ) : null}
              {show("lotSize", displayOverrides.lotSize) ? (
                <p className="property-attributes-text">
                  {displayOverrides.lotSize}
                </p>
              ) : null}
              {show("view", displayOverrides.view) ? (
                <p className="property-attributes-text">
                  {displayOverrides.view}
                </p>
              ) : null}
            </div>
          </div>
        </div>

        {this.renderEditButton()}
      </div>
    );
  };

  render() {
    let {
      rangeNum,
      baths,
      halfBaths,
      beds,
      dom,
      garageSpaces,
      golfView,
      sqft,
      lotSize,
      homesSold,
      oceanView,
      priceRangeLow,
      priceRangeHigh,
      agentData,
      currentArea,
      displayOverrides,
    } = this.props;

    if (displayOverrides) {
      return this.renderOverrideContent(displayOverrides);
    }

    const show = this.canShowField;
    const { mlsAreaID } = currentArea;

    const { listgenUserID } = agentData;
    const { homeOrProperties, getHomeOrCondo, getBathroomDecimals } = this;
    const { roundSalePriceTenths, acreOrSqft, toAcre } = propertyUtil;

    let specialVaitGarage = mlsAreaID === "SBA-20FRes" && rangeNum === 3;
    let useDecimal = false;
    if (listgenUserID === "102340" || `${baths}`.includes(".")) {
      useDecimal = true;
    }
    let garageText = "car garage";

    let bayOrOcean = "ocean";
    if (listgenUserID === "104835") {
      bayOrOcean = "bay";
    }
    if (baths === "1.5" && halfBaths === "0") {
      baths = "1";
      halfBaths = "1";
    }
    let propAttributesTitle = "Common Property Attributes";
    if (listgenUserID === "106531") {
      propAttributesTitle = "Average Home Features";
    }

    let useLotPlus = false;
    if (mlsAreaID === "SCL-14U") {
      useLotPlus = true;
    }

    let acreConvert = toAcre(lotSize, true);
    let useAcreOrSqft = acreOrSqft(lotSize, true);

    const { useTwoSectionLayout } = this.props;

    return (
      <div
        className={`dashboard-body-range${
          useTwoSectionLayout ? " dashboard-body-range-two-sections" : ""
        }`}
      >
        <div className="price-range-col">
          <div className="price-range-inner-container">
            {show("priceRange") ? (
              <div className="price-range-text">
                {roundSalePriceTenths(priceRangeLow)}
                {priceRangeHigh == "100000000"
                  ? " & up"
                  : ` - ${roundSalePriceTenths(priceRangeHigh)}`}
              </div>
            ) : (
              <div className="price-range-text" aria-hidden="true" />
            )}

            <div className="price-range-number">Price Range #{rangeNum}</div>
          </div>
        </div>
        <img
          className="range-details-img"
          src={White40Percent}
          alt="Transparent dashboard container"
        />
        <div
          className={`range-details-col-with-image range-detail-${rangeNum}`}
        >
          <div className="range-details-inner-container">
            <div className="range-property-details">
              {show("homesSold") ? (
                <p>
                  {homesSold} {homeOrProperties(homesSold)} Sold
                </p>
              ) : null}
              {show("daysToSell") && listgenUserID !== "110007" ? (
                <p>
                  {dom} {dom === "1" ? "Day" : "Days"} to Sell
                </p>
              ) : null}
            </div>
            {mlsAreaID === "SBA-45H" && rangeNum === 3 ? (
              <div className="property-attributes">
                <p className="property-attributes-title">
                  Common Property Attributes
                </p>

                {show("lotSize") &&
                  lotSize &&
                  +lotSize >= 1 &&
                  mlsAreaID !== "SBA-20FCondo" && (
                    <p className="property-attributes-text">
                      Lot Size: {acreConvert} {useAcreOrSqft}
                      {useLotPlus ? "+" : ""}
                    </p>
                  )}
              </div>
            ) : (
              <div className="property-attributes">
                {listgenUserID === "112334" ? (
                  <div className="double-prop-attributes-titles">
                    <p className="property-attributes-title">
                      Average Property Amenities
                    </p>
                  </div>
                ) : (
                  <p className="property-attributes-title">
                    {propAttributesTitle}
                  </p>
                )}

                {show("beds") ? (
                  <p className="property-attributes-text">
                    {beds} {beds === "1" ? "bedroom" : "bedrooms"}
                  </p>
                ) : null}

                {show("baths") ? (
                  useDecimal ? (
                    <p className="property-attributes-text">
                      {getBathroomDecimals(baths, halfBaths, rangeNum)}
                    </p>
                  ) : (
                    <p className="property-attributes-text">
                      {baths} full {baths === "1" ? "bath" : "baths"}{" "}
                      {+halfBaths > 0
                        ? `  +   ${halfBaths}
                  half ${halfBaths === "1" ? "bath" : "baths"}
                `
                        : ""}
                    </p>
                  )
                ) : null}

                {show("sqft") ? (
                  <p className="property-attributes-text">
                    {Number(sqft).toLocaleString()}
                    {(listgenUserID === "102340" ||
                      listgenUserID === "102356") &&
                      "+"}{" "}
                    Living Square Feet
                  </p>
                ) : null}
                {show("garage") &&
                  garageSpaces &&
                  +garageSpaces > 0 &&
                  !specialVaitGarage &&
                  mlsAreaID !== "SCL-13A" && (
                    <p className="property-attributes-text">
                      {listgenUserID === "107348"
                        ? "Garage"
                        : `${garageSpaces} ${garageText}`}
                    </p>
                  )}
                {show("garage") && specialVaitGarage && (
                  <p className="property-attributes-text">No Garage</p>
                )}
                {show("lotSize") &&
                  lotSize &&
                  +lotSize >= 1 &&
                  mlsAreaID !== "SBA-20FCondo" &&
                  mlsAreaID !== "SCL-13A" &&
                  listgenUserID !== "110007" && (
                    <p className="property-attributes-text">
                      Lot Size: {acreConvert} {useAcreOrSqft}
                      {useLotPlus ? "+" : ""}
                    </p>
                  )}
                {show("view") && +oceanView > 0 ? (
                  <p className="property-attributes-text">
                    {oceanView}{" "}
                    {`${getHomeOrCondo(oceanView)} an ${bayOrOcean} view`}
                  </p>
                ) : show("view") && +golfView > 0 ? (
                  <p className="property-attributes-text">
                    {golfView}{" "}
                    {`${getHomeOrCondo(golfView)} a golf course view`}
                  </p>
                ) : null}
              </div>
            )}
          </div>
        </div>

        {this.renderEditButton()}
      </div>
    );
  }
}
export default DashboardBodyRange;
